import { render, staticRenderFns } from "./FamCertify.vue?vue&type=template&id=b9159e2a&"
import script from "./FamCertify.vue?vue&type=script&lang=js&"
export * from "./FamCertify.vue?vue&type=script&lang=js&"
import style0 from "./FamCertify.vue?vue&type=style&index=0&lang=scss&slot-scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FamCertify.vue"
export default component.exports